export const hebrewDateType = {
    full: "full",
    day: "day",
    month: "month",
    year: "year",
    fullMonth: "fullMonth"
}